<template>
  <div>
    <homelogo />
    <v-img src="@/assets/comunidadVirtual/cabezote.jpg"></v-img>
    <v-row class="py-10">
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titlesCenter px-10">
          NUESTROS
          OBJETIVOS
        </h1>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <p class="parrafos1 px-10 text-center">
          Construir un espacio de interacción virtual empleando herramientas tecnológicas 
          innovadoras para optimizar el uso de los equipos tecnológicos donados por nuestra fundación.
          Capacitar en la Gestión adecuada de Residuos de Aparatos Electrónicos y
          Electrónicos -RAEE-, como esencia de nuestro proyecto socio-ambiental.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="6" md="12" sm="12" cols="12" class="px-0 py-0">
        <v-img src="@/assets/comunidadVirtual/imagen_parrafo_dos.jpg"></v-img>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12" class="px-12 py-0">
        <p class="parrafosBold">
          Es un espacio creado para aquellas personas
          que desarrollan acciones educativas con niños
          de edad escolar.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col lg="6" md="12" sm="12" cols="12" class="px-12 py-0">
        <p class="parrafosBold">
          Podemos encontrar herramientas pedagógicas
          haciendo uso de las tecnologías de la información
          <br />-TIC-
        </p>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12" class="px-0 py-0">
        <v-img src="@/assets/comunidadVirtual/imagen_parrafo_tres.jpg"></v-img>
      </v-col>
    </v-row>
    <br />
    <h1 class="text-center titles3 px-10">Nuestras Herramientas</h1>
    <br />
    <v-row>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Conoce tu PC</h1>
        <p class="parrafos1 px-10 text-center">
          Libro interactivo que te permitirá resolver dudas sobre el
          funcionamiento de tu PC, Portátil o Tablet.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Mundo RAEE</h1>
        <p class="parrafos1 px-10 text-center">
          Aplicación creada por nuestra fundación que muestra la
          clasificación y manejo adecuado de los RAEE mediante un
          juego interactivo.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Google AutoDraw</h1>
        <p class="parrafos1 px-10 text-center">
          La aplicación lanzada por Google permite crear dibujos
          fantásticos con solo unos trazos, gracias a la inteligencia
          artificial.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.autodraw.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Celebriti</h1>
        <p class="parrafos1 px-10 text-center">
          Esta es una plataforma permite aprender jugando sobre
          multitud de temáticas (ciencias, matemáticas, lenguaje,
          etc.) en cualquier curso escolar.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.cerebriti.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Storybird</h1>
        <p class="parrafos1 px-10 text-center">
          Si quieres conseguir que tu hijo lea y que mejore su redacción, Storybird te enamorará. Esta herramienta digital
          para niños está concebida precisamente para fomentar
          estas dos cualidades.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.storybird.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Mundo primaria</h1>
        <p class="parrafos1 px-10 text-center">
          La página web mundoprimaria.com agrupa multitud de
          herramientas digitales para niños, tanto en educación pri-
          maria como en infantil.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.mundoprimaria.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Edmodo</h1>
        <p class="parrafos1 px-10 text-center">
          Edmodo es una herramienta educativa que conecta a pro-
          fesores y estudiantes, la cual se asimila a una red social.
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.edmodo.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <h1 class="text-center titles3 px-10">Kahoot</h1>
        <p class="parrafos1 px-10 text-center">
          Kahoot es una plataforma educativa que se basa en
          juegos y en preguntas. Por medio de esta herramienta, los
          profesores pueden crear cuestionarios, discusiones o encuestas 
          que complementen las lecciones académicas, que
          se proyectan en el aula de clase y que son contestadas
          por los estudiantes, mientras juegan y aprenden al mismo
          tiempo
        </p>
        <div class="text-center">
          <v-btn rounded color="orange" href="https://www.kahoot.com" class="white--text r-btn">Utilizar ahora</v-btn>
        </div>
      </v-col>
    </v-row>
    <br />
    <v-img src="@/assets/comunidadVirtual/imagen_parrafo_tres.png" class="box-center">
      <v-row class="hidden-sm-and-down">
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 py-0"></v-col>
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 py-0">
          <p class="parrafosCenter white--text">
            Es nuesto canal informativo para garantizar una
            correcta gestión de los residuos electrónicos que
            se generan día a día.
          </p>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="hidden-md-and-up">
      <v-col cols="12" class="text-center pa-12">
        <p class="parrafosBold">
          Es nuesto canal informativo para garantizar una
          correcta gestión de los residuos electrónicos que
          se generan día a día.
        </p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";
export default {
  components: {
    homelogo
  }
};
</script>
<style scoped>
</style>